import { ChevronRight } from 'lucide-react';
import { LocationLink } from 'components/LocationLink';
import { CARD, CARD_EMPTY, CARD_HEADER, CARD_TITLE } from 'components/Dashboard/helper';
import { PORTAL_ROUTES } from 'utils/constants';
import Item from './Item';

const UpcomingAppointments = ({ appointments = [] }) => (
  <div className={`${CARD} flex flex-col overflow-hidden lg:min-h-0`}>
    <div className={`${CARD_HEADER} shrink-0`}>
      <p className={CARD_TITLE}>Upcoming appointments</p>

      <LocationLink
        to={PORTAL_ROUTES.APPOINTMENTS}
        className="ml-auto inline-flex items-center gap-0.5 text-[13px] font-semibold text-secondary-900 transition-colors hover:text-teamcare-blue"
      >
        See all
        <ChevronRight size={15} />
      </LocationLink>
    </div>

    {appointments.length ? (
      <div className="divide-y divide-gray-100 lg:min-h-0 lg:overflow-y-auto lg:overscroll-contain">
        {appointments.map((appointment) => <Item key={appointment.id} appointment={appointment} />)}
      </div>
    ) : (
      <p className={CARD_EMPTY}>No upcoming appointments. Schedule a visit to see it here.</p>
    )}
  </div>
);

export default UpcomingAppointments;
